import { HiOutlinePhone } from "react-icons/hi";
import SiteTitle from "../../helpers/SiteTitle/SiteTitle";

const ContactUs = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const phoneNumber = e.target.phoneNumber.value;

    // نمایش پیام موفقیت (می‌توانید این قسمت را تغییر دهید)
    alert(`شماره تلفن ${phoneNumber} ثبت شد!`);

    // ریست کردن فرم
    e.target.reset();
  };

  return (
    <>
      <SiteTitle title="تماس با ما" />
      <div className="mr-auto 2xl:w-[85%] xl:w-[75%] lg:w-[70%] w-full h-full">
        <div className="flex h-full justify-center items-center rounded-xl bg-[#101632] relative">
          <div className="rounded-xl flex flex-col h-full w-full animate__animated animate__fadeIn animate__fast">
            {/* Contact Form */}
            <span className="w-full flex flex-col items-center justify-center h-screen">
              <div className="flex flex-col items-center w-full p-5 space-y-5 bg-[#101632] text-gray-200 lg:text-2xl text-lg font-bold text-center">
                {/* Icon */}
                <span className="xl:w-[30%] md:w-[60%] w-full">
                  <HiOutlinePhone
                    size={135}
                    className="m-auto text-white rounded-full object-cover p-2 border-2 border-gray-200"
                  />
                </span>

                {/* Title */}
                <span className="xl:w-[30%] md:w-[60%] w-full p-6 border-2 border-gray-200 bg-[#153477] rounded-xl">
                  <h2 className="text-3xl font-bold mb-3">
                    با ما در تماس باشید
                  </h2>
                </span>

                {/* Contact Info */}
                <span className="xl:w-[30%] md:w-[60%] w-full p-6 border-2 border-gray-200 bg-[#153477] rounded-xl">
                  <h3 className="font-bold mb-4 text-2xl">اطلاعات تماس:</h3>

                  {/* Clickable Phone Number */}
                  <a
                    href="tel:09132984361"
                    className="text-xl text-gray-300 mb-2 hover:text-white transition-all"
                  >
                    تلفن حسابداری : ۴۳۶۱-۲۹۸-۰۹۱۳
                  </a>
<br/>
                  <a
                    href="tel:09131416369"
                    className="text-xl text-gray-300 mb-2 hover:text-white transition-all"
                  >
                    تلفن مدیریت : ۶۳۶۹-۱۴۱-۰۹۱۳
                  </a>

                  {/* <p className="text-xl text-gray-300">آدرس: تهران، خیابان نمونه</p> */}
                </span>
              </div>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
